export interface ComicChapter {
  id: string;
  number: number;
  title: string;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  categories: string[];
  status: string;
  chapters: ComicChapter[];
  rating: number;
  views: number;
  updatedAt: string;
  isHot: boolean;
  isNew: boolean;
}

export const allComics: Comic[] = [
  {
    id: "comic-1",
    title: "我的野蛮王妃",
    author: "朴熙珍",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20royal%20couple%20cover%20art%2C%20elegant%20princess%20in%20hanbok%20with%20modern%20prince%2C%20soft%20pastel%20background%2C%20beautiful%20illustration%20style%2C%20clean%20composition%2C%20dramatic%20lighting%2C%20romantic%20atmosphere&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    description: "一位普通的现代女孩意外穿越到朝鲜王朝，成为了王的未婚妻。面对复杂的宫廷斗争和未曾预料的爱情，她能否在这个陌生的时代找到属于自己的幸福？",
    categories: ["恋爱", "穿越"],
    status: "连载中",
    chapters: Array.from({ length: 86 }, (_, i) => ({ id: `ch-1-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 15))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.2,
    views: 1285000,
    updatedAt: "2026-08-03",
    isHot: true,
    isNew: false,
  },
  {
    id: "comic-2",
    title: "暗黑之城的守护者",
    author: "金志勋",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20warrior%20cover%20art%2C%20dark%20armored%20hero%20with%20sword%20in%20gothic%20city%2C%20dramatic%20moonlight%2C%20intense%20atmosphere%2C%20detailed%20illustration%2C%20epic%20fantasy%20style&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    description: "在黑暗之城阿尔卡迪亚，年轻的守护者凯因肩负着保护城市免受邪恶魔物侵袭的使命。随着一股古老力量的苏醒，他必须揭开隐藏在城市深处的秘密。",
    categories: ["奇幻", "动作"],
    status: "连载中",
    chapters: Array.from({ length: 120 }, (_, i) => ({ id: `ch-2-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 20))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.5,
    views: 2350000,
    updatedAt: "2026-08-04",
    isHot: true,
    isNew: false,
  },
  {
    id: "comic-3",
    title: "甜蜜的陷阱",
    author: "李秀妍",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sweet%20romance%20coffee%20shop%20cover%20art%2C%20beautiful%20barista%20couple%20in%20warm%20cafe%2C%20soft%20sunlight%2C%20romantic%20atmosphere%2C%20gentle%20colors%2C%20illustration%20style&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    description: "为了还清家里的债务，智恩来到首尔一家高级咖啡厅打工。没想到咖啡厅的老板竟是曾经暗恋过的学长。甜蜜又危险的爱情故事即将展开。",
    categories: ["恋爱", "都市"],
    status: "已完结",
    chapters: Array.from({ length: 65 }, (_, i) => ({ id: `ch-3-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(7, Math.ceil((i + 1) / 12))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 8.9,
    views: 980000,
    updatedAt: "2026-07-15",
    isHot: false,
    isNew: false,
  },
  {
    id: "comic-4",
    title: "阴间使者",
    author: "崔民浩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20grim%20reaper%20cover%20art%2C%20mysterious%20dark%20figure%20with%20scythe%20in%20foggy%20alley%2C%20supernatural%20atmosphere%2C%20cold%20blue%20tones%2C%20dramatic%20shadows%2C%20thriller%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    description: "能够看到鬼魂的大学生尹秀赫，某天遇到了自称阴间使者的神秘男子。从此，他被迫卷入了一场关于生死、命运和轮回的超自然事件之中。",
    categories: ["恐怖", "奇幻"],
    status: "连载中",
    chapters: Array.from({ length: 72 }, (_, i) => ({ id: `ch-4-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 12))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.0,
    views: 1560000,
    updatedAt: "2026-08-02",
    isHot: true,
    isNew: false,
  },
  {
    id: "comic-5",
    title: "校园搞笑日记",
    author: "韩智慧",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20school%20life%20cover%20art%2C%20funny%20students%20in%20classroom%2C%20bright%20colors%2C%20energetic%20poses%2C%20humorous%20illustration%20style%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    description: "四个性格迥异的高中生在日常校园生活中发生的各种爆笑故事。从考试作弊失败到恋爱大作战，每一话都让人捧腹大笑！",
    categories: ["搞笑", "校园"],
    status: "连载中",
    chapters: Array.from({ length: 95 }, (_, i) => ({ id: `ch-5-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 16))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 8.7,
    views: 1120000,
    updatedAt: "2026-08-03",
    isHot: false,
    isNew: true,
  },
  {
    id: "comic-6",
    title: "剑与魔法",
    author: "姜东元",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20cover%20art%2C%20young%20mage%20with%20staff%20and%20sword%20in%20magical%20forest%2C%20glowing%20runes%2C%20epic%20fantasy%20atmosphere%2C%20vibrant%20magical%20effects%2C%20detailed%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    description: "在一个魔法与剑术并存的世界里，少年艾伦从一个小小的佣兵开始，逐步成长为拯救世界的英雄。宏大的世界观，精彩的战斗场面。",
    categories: ["奇幻", "动作"],
    status: "连载中",
    chapters: Array.from({ length: 150 }, (_, i) => ({ id: `ch-6-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 25))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.3,
    views: 3100000,
    updatedAt: "2026-08-04",
    isHot: true,
    isNew: false,
  },
  {
    id: "comic-7",
    title: "都市夜归人",
    author: "张美淑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20city%20night%20cover%20art%2C%20lonely%20woman%20walking%20in%20rainy%20Seoul%20street%2C%20neon%20reflections%2C%20melancholic%20atmosphere%2C%20realistic%20illustration%20style%2C%20urban%20vibe&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    description: "在首尔的霓虹灯下，五个不同年龄、不同职业的都市人，各自面对着爱情、事业和人生的抉择。一部直击人心的都市情感故事。",
    categories: ["剧情", "都市"],
    status: "已完结",
    chapters: Array.from({ length: 48 }, (_, i) => ({ id: `ch-7-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(6, Math.ceil((i + 1) / 10))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.1,
    views: 870000,
    updatedAt: "2026-06-20",
    isHot: false,
    isNew: false,
  },
  {
    id: "comic-8",
    title: "九尾狐传",
    author: "尹素熙",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20nine-tailed%20fox%20cover%20art%2C%20mystical%20fox%20spirit%20woman%20in%20traditional%20Korean%20setting%2C%20magical%20auras%2C%20ethereal%20beauty%2C%20elegant%20composition%2C%20mysterious%20atmosphere&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    description: "修行千年的九尾狐为了成为真正的人类，必须收集一百个真心。当她遇到命中注定的那个人时，一切变得复杂起来。唯美又虐心的奇幻爱情故事。",
    categories: ["奇幻", "恋爱"],
    status: "连载中",
    chapters: Array.from({ length: 58 }, (_, i) => ({ id: `ch-8-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 10))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.4,
    views: 1890000,
    updatedAt: "2026-08-01",
    isHot: true,
    isNew: false,
  },
  {
    id: "comic-9",
    title: "重生之商业帝国",
    author: "朴正宇",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20rebirth%20cover%20art%2C%20confident%20young%20CEO%20in%20modern%20office%2C%20city%20skyline%20background%2C%20professional%20atmosphere%2C%20clean%20illustration%20style%2C%20warm%20lighting&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    description: "被合作伙伴背叛后，商业天才韩振宇重生回到了十年前。带着未来的记忆，他誓要打造一个属于自己的商业帝国，让所有背叛他的人都付出代价。",
    categories: ["剧情", "都市"],
    status: "连载中",
    chapters: Array.from({ length: 110 }, (_, i) => ({ id: `ch-9-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 18))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.0,
    views: 1720000,
    updatedAt: "2026-08-03",
    isHot: false,
    isNew: true,
  },
  {
    id: "comic-10",
    title: "深海恐惧",
    author: "孙贤宇",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20deep%20sea%20horror%20cover%20art%2C%20submarine%20exploring%20dark%20ocean%20depths%2C%20eerie%20creatures%2C%20claustrophobic%20atmosphere%2C%20dark%20blue%20tones%2C%20thriller%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    description: "一支深海科考队在太平洋深处发现了一座未知的古代遗迹。随着探索的深入，队员们开始一个接一个地消失，深海中似乎有什么东西正在注视着他们。",
    categories: ["恐怖", "科幻"],
    status: "连载中",
    chapters: Array.from({ length: 42 }, (_, i) => ({ id: `ch-10-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 7))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 8.8,
    views: 720000,
    updatedAt: "2026-08-02",
    isHot: false,
    isNew: true,
  },
  {
    id: "comic-11",
    title: "明星男友的秘密",
    author: "赵敏雅",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20celebrity%20romance%20cover%20art%2C%20handsome%20idol%20star%20with%20ordinary%20girl%2C%20sparkling%20stage%20lights%2C%20romantic%20celebrity%20vibe%2C%20glamorous%20atmosphere%2C%20beautiful%20illustration&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    description: "普通上班族林多海意外发现自己交往三年的男友竟然是韩国顶级偶像团体成员！面对疯狂的粉丝和媒体的关注，这段恋情能否继续？",
    categories: ["恋爱", "都市"],
    status: "连载中",
    chapters: Array.from({ length: 55 }, (_, i) => ({ id: `ch-11-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 9))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 8.6,
    views: 1450000,
    updatedAt: "2026-08-04",
    isHot: false,
    isNew: false,
  },
  {
    id: "comic-12",
    title: "武林至尊",
    author: "刘在石",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20master%20cover%20art%2C%20warrior%20in%20traditional%20robes%20with%20sword%2C%20mountain%20peak%20background%2C%20dramatic%20clouds%2C%20epic%20wuxia%20style%2C%20powerful%20stance&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    description: "武林中盛传的绝世武功秘籍重现江湖，各大门派纷纷出动争夺。出身卑微的少年江昊辰意外获得了这份力量，开启了一段快意恩仇的江湖之旅。",
    categories: ["动作", "奇幻"],
    status: "已完结",
    chapters: Array.from({ length: 135 }, (_, i) => ({ id: `ch-12-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(7, Math.ceil((i + 1) / 22))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.6,
    views: 4200000,
    updatedAt: "2026-07-30",
    isHot: true,
    isNew: false,
  },
  {
    id: "comic-13",
    title: "我的同桌是吸血鬼",
    author: "金艺琳",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20vampire%20school%20romance%20cover%20art%2C%20mysterious%20vampire%20boy%20in%20school%20uniform%2C%20moonlit%20classroom%2C%20dark%20romantic%20atmosphere%2C%20gothic%20elements%2C%20beautiful%20illustration&width=600&height=800&seq=comic-cover-13&orientation=portrait",
    description: "新学期换座位后，柳荷娜发现自己的新同桌身上有着一个惊天的秘密——他是一名活了三百年的吸血鬼。一场关于青春、友情和跨越种族的爱情故事。",
    categories: ["奇幻", "恋爱", "校园"],
    status: "连载中",
    chapters: Array.from({ length: 68 }, (_, i) => ({ id: `ch-13-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 11))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 8.9,
    views: 1350000,
    updatedAt: "2026-08-01",
    isHot: false,
    isNew: true,
  },
  {
    id: "comic-14",
    title: "末日求生指南",
    author: "权志龙",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalypse%20survival%20cover%20art%2C%20survivors%20in%20destroyed%20city%2C%20zombie%20apocalypse%2C%20dramatic%20survival%20scene%2C%20intense%20action%2C%20dark%20atmosphere&width=600&height=800&seq=comic-cover-14&orientation=portrait",
    description: "一场突如其来的病毒席卷全球，被感染的人类变成了嗜血的怪物。普通大学生韩哲民必须依靠自己的智慧和勇气，在这个末日世界中寻找生存的希望。",
    categories: ["恐怖", "动作"],
    status: "连载中",
    chapters: Array.from({ length: 88 }, (_, i) => ({ id: `ch-14-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 14))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.1,
    views: 1980000,
    updatedAt: "2026-08-04",
    isHot: true,
    isNew: false,
  },
  {
    id: "comic-15",
    title: "恋爱心理学",
    author: "安素英",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20university%20romance%20cover%20art%2C%20psychology%20students%20couple%20in%20library%2C%20warm%20autumn%20colors%2C%20intellectual%20atmosphere%2C%20gentle%20romantic%20vibe%2C%20soft%20illustration&width=600&height=800&seq=comic-cover-15&orientation=portrait",
    description: "心理学专业研究生徐敏俊遇到了让他心动的女孩，但作为一个精通恋爱心理学的学霸，他发现自己所学的理论在实践中完全派不上用场。",
    categories: ["恋爱", "校园"],
    status: "已完结",
    chapters: Array.from({ length: 52 }, (_, i) => ({ id: `ch-15-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(7, Math.ceil((i + 1) / 10))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 8.5,
    views: 690000,
    updatedAt: "2026-07-10",
    isHot: false,
    isNew: false,
  },
  {
    id: "comic-16",
    title: "魔王的继承人",
    author: "金泰亨",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20demon%20lord%20inheritance%20cover%20art%2C%20young%20man%20with%20demonic%20powers%2C%20dark%20castle%20background%2C%20purple%20magical%20auras%2C%20epic%20fantasy%20vibe%2C%20dramatic%20lighting&width=600&height=800&seq=comic-cover-16&orientation=portrait",
    description: "平凡高中生李明浩在18岁生日那天得知自己是魔王的转世。面对天使阵营的追杀和来自魔界的期望，他必须在光明与黑暗之间做出抉择。",
    categories: ["奇幻", "动作"],
    status: "连载中",
    chapters: Array.from({ length: 78 }, (_, i) => ({ id: `ch-16-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 13))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.0,
    views: 1610000,
    updatedAt: "2026-08-02",
    isHot: false,
    isNew: false,
  },
  {
    id: "comic-17",
    title: "办公室恋曲",
    author: "郑彩英",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20cover%20art%2C%20professional%20couple%20in%20modern%20office%2C%20city%20view%20through%20window%2C%20romantic%20tension%2C%20clean%20professional%20style%2C%20warm%20atmosphere&width=600&height=800&seq=comic-cover-17&orientation=portrait",
    description: "在同一家公司上班的崔智恩和她的直属上司朴俊浩之间，从最初的互相看不顺眼到逐渐萌生情愫。一段隐秘又甜蜜的办公室恋情。",
    categories: ["恋爱", "都市"],
    status: "连载中",
    chapters: Array.from({ length: 62 }, (_, i) => ({ id: `ch-17-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 10))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 8.7,
    views: 1050000,
    updatedAt: "2026-08-03",
    isHot: false,
    isNew: true,
  },
  {
    id: "comic-18",
    title: "异能觉醒",
    author: "李钟硕",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20superpower%20awakening%20cover%20art%2C%20teenager%20with%20energy%20powers%20in%20urban%20setting%2C%20electric%20effects%2C%20dynamic%20action%20pose%2C%20vibrant%20colors%2C%20superhero%20style&width=600&height=800&seq=comic-cover-18&orientation=portrait",
    description: "某一天，世界各地开始出现拥有超能力的人类。高中生朴志勋在觉醒能力后，被卷入了一场关于超能力者的秘密战争之中。",
    categories: ["动作", "科幻"],
    status: "连载中",
    chapters: Array.from({ length: 100 }, (_, i) => ({ id: `ch-18-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 16))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.3,
    views: 2750000,
    updatedAt: "2026-08-04",
    isHot: true,
    isNew: false,
  },
  {
    id: "comic-19",
    title: "深夜食堂",
    author: "河正宇",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20late%20night%20diner%20cover%20art%2C%20warm%20restaurant%20at%20night%2C%20chef%20cooking%2C%20cozy%20atmosphere%2C%20steaming%20food%2C%20slice%20of%20life%20illustration%2C%20soft%20warm%20lighting&width=600&height=800&seq=comic-cover-19&orientation=portrait",
    description: "午夜时分，一家不起眼的小食堂准时开门。每个夜晚，形形色色的客人带着各自的故事来到这里。食物温暖了胃，也温暖了心。",
    categories: ["剧情", "治愈"],
    status: "连载中",
    chapters: Array.from({ length: 45 }, (_, i) => ({ id: `ch-19-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 8))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.2,
    views: 830000,
    updatedAt: "2026-08-01",
    isHot: false,
    isNew: false,
  },
  {
    id: "comic-20",
    title: "游戏世界生存记",
    author: "边伯贤",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20game%20world%20survival%20cover%20art%2C%20gamer%20trapped%20in%20fantasy%20game%2C%20RPG%20elements%2C%20virtual%20world%2C%20colorful%20adventure%20style%2C%20dynamic%20composition&width=600&height=800&seq=comic-cover-20&orientation=portrait",
    description: "全球最受欢迎的VR游戏《永恒大陆》发生异常，数百万玩家被困其中。游戏达人姜泰民必须在游戏中生存下来，找到回到现实世界的方法。",
    categories: ["科幻", "动作", "奇幻"],
    status: "连载中",
    chapters: Array.from({ length: 92 }, (_, i) => ({ id: `ch-20-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 15))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.4,
    views: 2650000,
    updatedAt: "2026-08-04",
    isHot: true,
    isNew: false,
  },
  {
    id: "comic-21",
    title: "花店物语",
    author: "金智秀",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20flower%20shop%20romance%20cover%20art%2C%20beautiful%20florist%20girl%20in%20colorful%20flower%20shop%2C%20spring%20atmosphere%2C%20pastel%20colors%2C%20gentle%20romantic%20mood%2C%20soft%20illustration&width=600&height=800&seq=comic-cover-21&orientation=portrait",
    description: "继承了奶奶留下的花店后，沈珠妍发现每一束花背后都藏着一个动人的故事。在打理花店的过程中，她也邂逅了属于自己的那份爱情。",
    categories: ["治愈", "恋爱"],
    status: "已完结",
    chapters: Array.from({ length: 38 }, (_, i) => ({ id: `ch-21-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(6, Math.ceil((i + 1) / 8))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.0,
    views: 590000,
    updatedAt: "2026-06-30",
    isHot: false,
    isNew: false,
  },
  {
    id: "comic-22",
    title: "神级玩家",
    author: "都暻秀",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20esports%20gamer%20cover%20art%2C%20professional%20gamer%20in%20gaming%20arena%2C%20competitive%20esports%20scene%2C%20dynamic%20lighting%2C%20intense%20focus%2C%20modern%20arena%20background&width=600&height=800&seq=comic-cover-22&orientation=portrait",
    description: "从网吧打游戏被家人嫌弃，到站上世界电竞舞台的冠军领奖台。林宇轩的电竞之路充满了汗水、泪水和荣耀。",
    categories: ["剧情", "竞技"],
    status: "连载中",
    chapters: Array.from({ length: 56 }, (_, i) => ({ id: `ch-22-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 9))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 8.8,
    views: 980000,
    updatedAt: "2026-08-02",
    isHot: false,
    isNew: true,
  },
  {
    id: "comic-23",
    title: "灵异侦探社",
    author: "宋仲基",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20detective%20cover%20art%2C%20detective%20duo%20investigating%20haunted%20house%2C%20mysterious%20paranormal%20atmosphere%2C%20flashlight%20beams%2C%20dark%20thriller%20style&width=600&height=800&seq=comic-cover-23&orientation=portrait",
    description: "拥有通灵能力的私家侦探沈恩浩，与科学至上的法医韩素媛组成搭档，共同解决各种超自然案件。科学与灵异的碰撞，真相永远超乎想象。",
    categories: ["恐怖", "悬疑"],
    status: "连载中",
    chapters: Array.from({ length: 64 }, (_, i) => ({ id: `ch-23-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(8, Math.ceil((i + 1) / 11))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 8.9,
    views: 1170000,
    updatedAt: "2026-08-03",
    isHot: false,
    isNew: false,
  },
  {
    id: "comic-24",
    title: "重返十八岁",
    author: "姜素拉",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20back%20to%20youth%20cover%20art%2C%20middle-aged%20man%20turned%20teenager%20in%20school%2C%20comedy%20contrast%2C%20bright%20school%20setting%2C%20fun%20illustration%20style%2C%20warm%20nostalgic%20vibe&width=600&height=800&seq=comic-cover-24&orientation=portrait",
    description: "40岁的落魄大叔在一次意外后重返18岁的高中时代。带着成年人的阅历和经验，这次他要重新活出不一样的人生！",
    categories: ["搞笑", "校园", "剧情"],
    status: "已完结",
    chapters: Array.from({ length: 80 }, (_, i) => ({ id: `ch-24-${i + 1}`, number: i + 1, title: `第${i + 1}话`, updatedAt: `2026-0${Math.min(7, Math.ceil((i + 1) / 14))}-${String(Math.max(1, (i % 28) + 1)).padStart(2, '0')}` })),
    rating: 9.3,
    views: 2100000,
    updatedAt: "2026-07-25",
    isHot: true,
    isNew: false,
  },
];

export const categories = ["全部", "恋爱", "奇幻", "动作", "恐怖", "搞笑", "剧情", "都市", "校园", "科幻", "竞技", "治愈", "悬疑", "穿越"];

export const features = [
  {
    icon: "ri-book-open-line",
    title: "海量韩漫资源",
    description: "收录超过数千部韩国漫画，涵盖恋爱、奇幻、动作、恐怖等多种类型，满足各种阅读偏好。",
  },
  {
    icon: "ri-flashlight-line",
    title: "极速更新",
    description: "与韩国漫画平台同步更新，新章节上线速度行业领先，让您第一时间追更心爱的漫画。",
  },
  {
    icon: "ri-smartphone-line",
    title: "下拉式阅读",
    description: "专为手机优化的下拉式阅读模式，无需翻页，流畅自然，带来沉浸式的漫画阅读体验。",
  },
  {
    icon: "ri-money-cny-circle-line",
    title: "完全免费",
    description: "所有漫画资源完全免费开放，无需付费订阅，无需积分兑换，真正实现零门槛畅享阅读。",
  },
  {
    icon: "ri-image-line",
    title: "高清画质",
    description: "提供高清漫画画质，每一格画面都清晰细腻，完美呈现韩国漫画的精美画风和细节。",
  },
  {
    icon: "ri-user-heart-line",
    title: "个性化推荐",
    description: "基于您的阅读历史和偏好，智能推荐您可能喜欢的漫画，发现更多精彩内容。",
  },
];

export const faqs = [
  {
    question: "酷漫屋的漫画都是免费的吗？",
    answer: "是的，酷漫屋平台上所有的韩国漫画资源均完全免费开放。您无需付费订阅，无需充值积分，即可畅享所有漫画的在线阅读服务。我们致力于为韩漫爱好者提供无障碍的阅读体验。",
  },
  {
    question: "如何使用下拉式阅读模式？",
    answer: "进入任何漫画的阅读页面后，您只需向上或向下滑动屏幕即可连续阅读，无需点击翻页按钮。这种下拉式阅读模式专为移动端优化，为您提供如瀑布般流畅的阅读体验。",
  },
  {
    question: "漫画更新频率是怎样的？",
    answer: "我们与韩国各大漫画平台保持紧密同步，热门连载漫画通常每周更新1-2话。新章节上线后，您可以在首页的「最近更新」板块第一时间看到，也可以关注喜欢的漫画获取更新提醒。",
  },
  {
    question: "支持哪些设备阅读？",
    answer: "酷漫屋采用响应式网页设计，完美支持手机、平板和电脑等多种设备。无论您使用iOS、Android还是Windows系统，只需打开浏览器访问酷漫屋即可随时随地畅享韩漫阅读。",
  },
  {
    question: "如何找到我想看的漫画？",
    answer: "您可以通过顶部导航栏的分类浏览功能，按类型筛选漫画；也可以使用搜索功能直接搜索漫画名称或作者。此外，首页的推荐和排行榜也能帮助您发现热门优质漫画。",
  },
  {
    question: "漫画加载慢怎么办？",
    answer: "漫画加载速度受网络环境影响。建议您在稳定的Wi-Fi或移动网络环境下阅读。如果持续出现加载问题，可以尝试刷新页面或清除浏览器缓存。我们的服务器采用CDN加速，通常情况下加载速度很快。",
  },
];

export const testimonials = [
  {
    name: "小雨",
    avatar: "https://readdy.ai/api/search-image?query=young%20Asian%20woman%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-01&orientation=squarish",
    comment: "在这里看了大半年的韩漫了，更新超快！最喜欢《暗黑之城的守护者》，画风太绝了。推荐给所有喜欢韩漫的朋友！",
    rating: 5,
  },
  {
    name: "阿星",
    avatar: "https://readdy.ai/api/search-image?query=young%20Asian%20man%20portrait%2C%20warm%20smile%2C%20modern%20style%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-02&orientation=squarish",
    comment: "朋友推荐的酷漫屋，一发不可收拾！下拉式阅读太方便了，上班摸鱼必备哈哈。资源也很全，想看的都有。",
    rating: 5,
  },
  {
    name: "猫猫爱吃鱼",
    avatar: "https://readdy.ai/api/search-image?query=young%20Asian%20woman%20portrait%2C%20cute%20smile%2C%20natural%20look%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish",
    comment: "免费而且没有广告弹窗，这点真的太好了！漫画种类也很多，恋爱和奇幻类的韩漫基本都在这里看。",
    rating: 5,
  },
];